import { HeadlineCarouselModelType } from 'src/api/config/headlineCarousel/getHeadlineCarousel';
import { HeadlineCarouselDataState } from 'src/AppState/CmsState/HeadlineCarouselDataState/HeadlineCarouselData.state';
interface PropsType {
    headlineCarousel: HeadlineCarouselModelType,
    headlineCarouselsData: HeadlineCarouselDataState,
}

export class SingleHeadlineCarouselState {
    constructor(
        private readonly props: PropsType,
    ) {
    }

    edit = async (): Promise<void> => {
        this.props.headlineCarouselsData.setEditMode(true);
        await this.props.headlineCarouselsData.setEditHeadline(this.props.headlineCarousel);

    };

    delete = async (): Promise<void> => {
        await this.props.headlineCarouselsData.deleteCarousel(this.props.headlineCarousel.id);
    }

    setPublished = async (): Promise<void> => {
        await this.props.headlineCarouselsData.setPublished(this.props.headlineCarousel.id);
    }

    moveUp = async (): Promise<void> => {
        await this.props.headlineCarouselsData.moveItemUp(this.props.headlineCarousel.id);
    }

    moveDown = async (): Promise<void> => {
        await this.props.headlineCarouselsData.moveItemDown(this.props.headlineCarousel.id);
    }
}
